import React from 'react';
import { IconButton, CircularProgress, Box } from '@mui/material';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Pause from '@mui/icons-material/Pause';
import type { PlayPauseButtonProps } from '../DiscordAudioPlayer.types';
import { getPlayButtonStyles } from '../DiscordAudioPlayer.styles';
import { PLAYER_SIZES } from '../utils/constants';

/**
 * Play/Pause button component with loading state).
 */
export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  isPlaying,
  disabled = false,
  isLoading = false,
  size = PLAYER_SIZES.medium.buttonSize,
  iconSize = PLAYER_SIZES.medium.iconSize,
  onClick,
  sizeVariant = 'medium',
  sx,
}) => {
  return (
    <Box sx={{ display: 'inline-flex', position: 'relative' }}>
      <IconButton
        onClick={onClick}
        disabled={disabled || isLoading}
        aria-label={isPlaying ? 'Pause' : 'Play'}
        sx={[
          getPlayButtonStyles(sizeVariant),
          {
            height: size,
            minWidth: size,
            width: size,
          },
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
      >
        {isPlaying ? (
          <Pause sx={{ fontSize: iconSize }} />
        ) : (
          <PlayArrow sx={{ fontSize: iconSize }} />
        )}
      </IconButton>

      {isLoading && (
        <CircularProgress
          size={size}
          sx={{
            color: 'rgba(255, 255, 255, 0.8)',
            left: 0,
            position: 'absolute',
            top: 0,
          }}
        />
      )}
    </Box>
  );
};

export default PlayPauseButton;
